import type { ComponentProps } from 'react';
import AnyLink from '../../navigation-lib/any-link';
import Button2 from '../Button2';

type Props = Omit<ComponentProps<typeof Button2>, 'component'> & ComponentProps<typeof AnyLink>;

export function LinkButton(props: Props) {
  return <Button2 {...props} component={AnyLink} />;
}
